<template>
    <div ref="emailConsultItem" :class="classes">
        <template v-if="isOpen">
            <div ref="emailConsultItemHeaderOpen" :class="headerClasses" @click="handleHeaderClick">
                <div class="email-consult__address-details">
                    <CompassAvatar
                        size="small"
                        :initials="senderInitials"
                        :avatarColorType="avatarColor(email.from.name)"
                    />
                    <div class="email-consult__address-details-wrapper">
                        <div class="email-consult__sender">
                            <div
                                class="email-consult__sender-name typographies-paragraph-medium-semibold"
                            >
                                {{ email.from.name }}
                            </div>
                            <div
                                class="email-consult__sender-email typographies-paragraph-small-regular"
                            >
                                ({{ email.from.email }})
                            </div>
                        </div>
                        <div class="email-consult__recipients">
                            <div class="email-consult__recipients-label">{{ labelTo }}:</div>
                            <div
                                class="email-consult__recipients-list"
                                :class="{ 'is-expaned': isExpanded }"
                            >
                                {{ formattedRecipients }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="email-consult__extra-information">
                    <div>
                        <div class="email-consult__sent-date typographies-paragraph-small-regular">
                            {{ formattedSentDate }}
                        </div>
                        <div
                            v-if="attachmentCount > 0"
                            class="email-consult__attachments-count typographies-paragraph-small-semibold"
                        >
                            <CompassIcon size="small" icon="attachment" />
                            {{ formattedAttachmentCount }}
                        </div>
                    </div>
                    <div class="email-consult__actions">
                        <CompassTooltip
                            :disabled="canSendEmail"
                            :content="$t.__('email.EmailPanel.error_reconnect_email_account')"
                            placement="bottom-end"
                        >
                            <CompassIconButton
                                icon="reply"
                                size="small"
                                :disabled="!canSendEmail"
                                @click.stop="handleReply"
                            />
                        </CompassTooltip>
                    </div>
                </div>
            </div>
            <div class="email-consult__content typographies-paragraph-medium-regular">
                <EmailRelatedObject v-if="hasRelatedObject" :object="thread[0].linked_object" />
                <div
                    class="email-consult__content-text"
                    :class="editorClass"
                    v-html="addBrToEmptyPragraphs(email.content)"
                />
            </div>
            <div v-if="attachmentCount > 0" class="email-consult__attachments">
                <div class="email-consult__attachments-summary">
                    <span class="typographies-paragraph-medium-semibold">
                        {{ formattedAttachmentCount }}
                    </span>
                    <span
                        class="email-consult__attachments-weight typographies-paragraph-medium-regular"
                        >({{ formatBytes(attachmentsSize) }} au total)</span
                    >
                </div>
                <div class="email-consult__attachments-list">
                    <EmailAttachmentLink
                        v-for="attachment in email.attachments"
                        :key="attachment.id"
                        :file="attachment"
                    />
                </div>
            </div>
        </template>
        <template v-else>
            <div :class="headerClasses" @click.stop="handleHeaderClick">
                <CompassAvatar
                    size="small"
                    :initials="senderInitials"
                    :avatarColorType="avatarColor(email.from.name)"
                />
                <div
                    class="email-consult__header--snippet-wrapper"
                    :style="!isOpen ? 'width: 100%' : ''"
                >
                    <div class="email-consult__header--snippet-information">
                        <div class="email-consult__address-details-wrapper">
                            <div class="email-consult__sender">
                                <div
                                    class="email-consult__sender-name typographies-paragraph-medium-semibold"
                                >
                                    {{ email.from.name }}
                                </div>
                                <div
                                    class="email-consult__sender-email typographies-paragraph-small-regular"
                                >
                                    ({{ email.from.email }})
                                </div>
                            </div>
                            <div class="email-consult__recipients">
                                <div class="email-consult__recipients-label">{{ labelTo }}:</div>
                                <div
                                    class="email-consult__recipients-list"
                                    :class="{ 'is-expaned': isExpanded }"
                                >
                                    {{ formattedRecipients }}
                                </div>
                            </div>
                        </div>
                        <div class="email-consult__sent-date typographies-paragraph-small-regular">
                            <CompassIcon
                                v-if="attachmentCount > 0"
                                size="small"
                                icon="attachment"
                            />
                            {{ formattedSentDate }}
                        </div>
                    </div>
                    <div class="email-consult__snippet" v-html="sanitizedSnippet"></div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import AvatarMixins from 'mixins/AvatarMixins';
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateUser } = createNamespacedHelpers('user');
import EmailRelatedObject from 'vcomponents/email/EmailRelatedObject.vue';
import EmailAttachmentLink from 'vcomponents/email/EmailAttachmentLink.vue';
import { editorClass, addBrToEmptyPragraphs } from 'Helpers/richTextHelper.js';

export default {
    components: { EmailRelatedObject, EmailAttachmentLink },
    mixins: [AvatarMixins],
    props: {
        email: {
            type: Object,
            required: true,
        },
        showContent: {
            type: Boolean,
            default: false,
        },
        unique: {
            type: Boolean,
            default: true,
        },
        thread: {
            type: Array,
            required: true,
        },
        isCurrentEmail: {
            type: Boolean,
            default: false,
        },
        canSendEmail: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isExpanded: false,
            labelTo: this.$t.__('email.EmailConsultPanelItem.to'),
            attachments: [
                {
                    id: 1,
                    name: 'FACT-2023-09-04-Super-facture-avec-un-nom-super-long',
                    extension: 'gif',
                    public_link: 'https://media.giphy.com/media/T8Dhl1KPyzRqU/giphy.gif',
                },
                {
                    id: 2,
                    name: 'FACT 2023 09 04 Super facture avec un nom super long',
                    extension: 'pdf',
                    public_link: 'http://www.google.fr/',
                },
            ],
        };
    },
    computed: {
        ...mapStateUser({
            userForename: 'forename',
            name: 'name',
        }),
        editorClass,
        classes() {
            return ['email-consult', this.isOpen ? 'email-consult--is-open' : ''];
        },
        isOpen() {
            return this.isExpanded || !this.isSnippet;
        },
        headerClasses() {
            return [
                'email-consult__header',
                !this.showContent && 'email-consult__header--clickable',
                (!this.isExpanded || this.isSnippet) && 'email-consult__header--snippet',
            ];
        },
        senderInitials() {
            const { from } = this.email;
            const [firstName, lastName] = from.name ? from.name.split(' ') : [null, null];
            const initials = `${firstName ? firstName[0] : ''}${lastName ? lastName[0] : ''}`;
            return initials;
        },
        attachmentCount() {
            return this.email.attachments.length;
        },
        attachmentsSize() {
            return this.email.attachments
                .map((item) => item.size)
                .reduce((sum, value) => sum + value, 0);
        },
        formattedAttachmentCount() {
            return this.$l10n.n__(
                '%(nb)d pièce-jointe',
                '%(nb)d pièce-jointes',
                this.attachmentCount,
                { nb: this.attachmentCount },
            );
        },
        formattedSentDate() {
            const locale = window.App.lang;
            moment.locale(locale);

            const momentDate = moment(this.email.created);
            const separator = this.$t.__('email.EmailConsultPanelItem.dateTo');

            let formattedDate =
                locale === 'fr'
                    ? momentDate.format(`ddd DD MMM YYYY [${separator}] HH:mm`)
                    : momentDate.format(`ddd, MMM DD, YYYY [${separator}] HH:mm`);

            const differenceBetweenSentDateAndNow = moment().diff(
                moment(this.email.created),
                'days',
            );
            if (differenceBetweenSentDateAndNow > 0 && differenceBetweenSentDateAndNow <= 14) {
                formattedDate += ` (${moment(this.email.created).fromNow()})`;
            }

            return formattedDate;
        },
        formattedRecipients() {
            const to = this.email.to
                .map((item) => {
                    if (item.name && item.email) {
                        return `${item.name} (${item.email})`;
                    }
                    return item.name || item.email;
                })
                .filter((item) => item);

            const cc = this.email.cc.map((item) => item.name ?? item.email).filter((name) => name);
            const bcc = this.email.bcc
                .map((item) => item.name ?? item.email)
                .filter((name) => name);

            const combined = [...to, ...cc, ...bcc];
            const uniqueItems = new Set(combined);

            return Array.from(uniqueItems)
                .filter((item) => item)
                .join(', ');
        },
        isSnippet() {
            if (this.unique) {
                return false;
            }
            return !this.showContent;
        },
        sanitizedSnippet() {
            if (this.email.content.length > 30 && !this.isOpen) {
                return this.email.content.substring(0, 30) + '...';
            } else {
                return this.email.content;
            }
        },
        hasRelatedObject() {
            return (
                this.thread.length &&
                !!this.thread[0].linked_object &&
                typeof this.thread[0].linked_object === 'object'
            );
        },
    },
    mounted() {
        this.scrollToCurrentEmail();
    },
    methods: {
        addBrToEmptyPragraphs,
        handleHeaderClick() {
            if (!this.unique) {
                this.isExpanded = !this.isExpanded;
            }
        },
        handleReply() {
            this.$emit('reply');
        },
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0' + this.$l10n.n__(' Octet');

            const k = 1000;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Octets', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${this.$l10n.n__(
                '%s',
                '%s',
                sizes[i],
                sizes[i],
            )}`;
        },
        scrollToCurrentEmail() {
            if (!this.unique && this.isCurrentEmail) {
                const contentPanelHeight = this.$parent.$el.clientHeight;
                const scrollablePanelContainer = this.$parent.$el.querySelector(
                    '.compass-panel__scrollable',
                );
                const scrollablePanelContainerHeight = scrollablePanelContainer.clientHeight;

                if (contentPanelHeight > scrollablePanelContainerHeight) {
                    const panelContentPaddingTop = parseFloat(
                        getComputedStyle(this.$parent.$el.querySelector('.compass-panel__content'))
                            .paddingTop,
                    );
                    const currentEmailOffsetTop = this.$refs.emailConsultItem.offsetTop;
                    const currentEmailPaddingTop = parseFloat(
                        getComputedStyle(this.$refs.emailConsultItem).paddingTop,
                    );
                    const currentEmailHeaderHeight =
                        this.$refs.emailConsultItemHeaderOpen.clientHeight;
                    const emailItemCloseHeight = this.$parent.$el.querySelector(
                        '.email-consult:not(.email-consult--is-open)',
                    ).clientHeight;
                    scrollablePanelContainer.scrollTop =
                        currentEmailOffsetTop -
                        panelContentPaddingTop -
                        currentEmailPaddingTop -
                        currentEmailHeaderHeight -
                        emailItemCloseHeight / 2;
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.email-consult {
    padding: var(--spacing-3) 0;
    width: 100%;
    word-break: break-word;

    .is-expaned {
        white-space: normal;
    }

    &--is-open {
        padding: var(--spacing-3) 0 var(--spacing-5);

        .email-consult__header {
            margin: 0 0 var(--spacing-2);
        }
    }

    + .email-consult {
        border-top: 1px solid var(--colors-common-border-default);
    }

    &__header {
        display: flex;
        margin: 0;
        justify-content: space-between;

        &--clickable {
            cursor: pointer;
        }

        &--snippet {
            display: flex;
            justify-content: space-between;
            gap: var(--spacing-3);

            &-wrapper {
                width: 100%;
                min-width: 0; // to stop overflow-x due to snippet white space
            }

            &-information {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
            }
        }
    }

    &__address-details {
        display: flex;
        gap: var(--spacing-3);
        min-width: 0;

        &-wrapper {
            min-width: 0;
        }
    }

    &__sender {
        align-items: baseline;
        flex-wrap: wrap;
        display: flex;

        &-name {
            margin-right: var(--spacing-0);
        }

        &-email {
            color: var(--colors-common-text-standard-caption);
        }
    }

    &__recipients {
        color: var(--colors-common-text-subtle-default);
        display: flex;
        gap: var(--spacing-0);
        font-size: 12px;
        line-height: 20px;

        &-list {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    &__extra-information {
        display: flex;
        flex-shrink: 0;
        gap: var(--spacing-2);
    }

    &__sent-date {
        align-items: center;
        color: var(--colors-common-text-subtle-default);
        display: flex;
        gap: 4px;
        margin: 2px 0 1px;
    }

    &__attachments-count {
        align-items: center;
        color: var(--colors-common-text-subtle-default);
        display: flex;
        gap: var(--spacing-0);
    }

    &__content {
        padding: 0 0 0 48px;
        &-text {
            :deep() {
                p {
                    margin: 0;
                }
            }
        }
    }

    &__attachments {
        border-top: 1px solid var(--colors-common-border-lighter);
        margin: var(--spacing-3) 0 0 var(--spacing-5);
        padding: var(--spacing-2) 0 0;

        &-summary {
            margin: 0 0 var(--spacing-1);
        }

        &-weight {
            color: var(--colors-common-text-standard-caption);
        }

        &-list {
            display: flex;
            flex-wrap: wrap;
            gap: var(--spacing-0);
        }
    }

    &__snippet {
        color: var(--colors-common-text-standard-caption);
        font-family: 'Proxima Nova';
        font-size: 12px;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        :deep() {
            p:last-of-type {
                margin-bottom: 0;
            }
        }
    }
}
</style>
